var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "border-top": "thin solid rgba(0, 0, 0, 0.12)",
        "margin-right": "14px"
      }
    },
    [
      _c(
        "v-row",
        {
          staticStyle: {
            padding: "0 0 2px 0",
            "font-size": "12px",
            height: "58px"
          },
          attrs: { align: "center", dense: "", "no-gutters": "" }
        },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { margin: "auto 34px auto 0", "font-size": "12px" }
            },
            [_vm._v("\n      Rows per page:\n    ")]
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticStyle: { margin: "0 22px 0 0", padding: "0" },
              attrs: { cols: "auto" }
            },
            [
              _c("v-select", {
                staticStyle: {
                  margin: "0px 0 13px 0",
                  "font-size": "12px",
                  width: "auto",
                  "max-width": "60px"
                },
                attrs: {
                  "hide-details": "",
                  items: _vm.pageSizes,
                  value: _vm.pageSize
                },
                on: {
                  change: function($event) {
                    return _vm.$emit("update:pageSize", $event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "grid",
                "grid-auto-flow": "column",
                "grid-auto-columns": "auto",
                "align-content": "center"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "12px",
                    margin: "auto 18px auto 20px"
                  }
                },
                [_vm._v("\n        Page " + _vm._s(_vm.page) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "grid",
                    "grid-auto-flow": "column",
                    "grid-auto-columns": "auto",
                    "align-content": "center"
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { icon: "", disabled: _vm.disablePrevious },
                      on: {
                        click: function($event) {
                          return _vm.$emit("previous")
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { icon: "", disabled: _vm.disableNext },
                      on: {
                        click: function($event) {
                          return _vm.$emit("next")
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d160e12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d160e12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PagingFooter.vue
// module id = null
// module chunks = 